import React, { createContext, useState, useContext } from 'react';

interface SidebarContextType {
  isCollapsed: boolean;
  isHovered: boolean;
  isPinned: boolean;
  setIsCollapsed: (collapsed: boolean) => void;
  setIsHovered: (hovered: boolean) => void;
  setIsPinned: (pinned: boolean) => void;
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

export const SidebarProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [isHovered, setIsHovered] = useState(false);
  const [isPinned, setIsPinned] = useState(false);

  return (
    <SidebarContext.Provider value={{ isCollapsed, isHovered, isPinned, setIsCollapsed, setIsHovered, setIsPinned }}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
};